export const prizeTypes = [
  {
    label: 'Christmas tree',
    value: 'christmas_tree',
  },
  {
    label: 'SuperPrize: 10 000 USD',
    value: 'usd_10000',
  },
  {
    label: 'iMac Pro',
    value: 'imac_pro',
  },
  {
    label: 'MacBook Pro',
    value: 'macbook_pro',
  },
  {
    label: 'Samsung Galaxy Book2 Pro',
    value: 'samsung_galaxy_book2_pro',
  },
  {
    label: 'IPhone 17',
    value: 'iphone_17',
  },
  {
    label: 'Samsung S25 Ultra',
    value: 'samsung_s25_ultra',
  },
  {
    label: 'Samsung Galaxy Watch',
    value: 'samsung_galaxy_watch',
  },
  {
    label: 'Apple Watch',
    value: 'apple_watch',
  },
  {
    label: 'Golden Bar 1g',
    value: 'golden_bar_1g',
  },
  {
    label: 'AirPods',
    value: 'air_pods',
  },
  {
    label: 'Other phones',
    value: 'smartphone',
  },
  {
    label: '5 USD',
    value: 'usd_5',
  },
]
